import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const browseIntentsRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-virtualagent-browse-intents',
	exact: true,
	path: '/jira/servicedesk/projects/:projectKey/settings/virtual-agent/intents',
};
